import { NoImageProps } from './noImage.types'

const NoImage = ({ className }: NoImageProps) => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="96" height="96" fill="#F4F7F8" />
      <path
        d="M57.5259 39.4138H38.4741C37.2376 39.4138 36.2759 40.4213 36.2759 41.6121V54.8017C36.2759 56.0383 37.2376 57 38.4741 57H57.5259C58.7166 57 59.7241 56.0383 59.7241 54.8017V41.6121C59.7241 40.4213 58.7166 39.4138 57.5259 39.4138ZM58.2586 54.8017C58.2586 55.2139 57.8922 55.5345 57.5259 55.5345H38.4741C38.062 55.5345 37.7414 55.2139 37.7414 54.8017V41.6121C37.7414 41.2457 38.062 40.8793 38.4741 40.8793H57.5259C57.8922 40.8793 58.2586 41.2457 58.2586 41.6121V54.8017ZM41.4052 47.1078C42.7791 47.1078 43.9698 45.9628 43.9698 44.5431C43.9698 43.1692 42.7791 41.9784 41.4052 41.9784C39.9855 41.9784 38.8405 43.1692 38.8405 44.5431C38.8405 45.9628 39.9855 47.1078 41.4052 47.1078ZM41.4052 43.444C42.0005 43.444 42.5043 43.9477 42.5043 44.5431C42.5043 45.1843 42.0005 45.6422 41.4052 45.6422C40.764 45.6422 40.306 45.1843 40.306 44.5431C40.306 43.9477 40.764 43.444 41.4052 43.444ZM50.8852 44.5431L46.5345 48.8939L45.069 47.4741C44.6568 47.0162 43.9698 47.0162 43.5577 47.4741L39.5275 51.5043C39.3443 51.6417 39.2069 52.0081 39.2069 52.2371V53.5194C39.2069 53.84 39.4359 54.069 39.7565 54.069H56.2435C56.5183 54.069 56.7931 53.84 56.7931 53.5194V49.306C56.7931 49.0312 56.6557 48.7565 56.4267 48.5733L52.3966 44.5431C51.9844 44.0851 51.2974 44.0851 50.8852 44.5431ZM55.3276 52.6034H40.6724V52.4203L44.3362 48.7565L46.5345 50.9547L51.6638 45.8254L55.3276 49.4892V52.6034Z"
        fill="#9EA4AC"
      />
    </svg>
  )
}

export default NoImage
